export default __webpack_public_path__ + "static/media/output_bg.8d6ede38.png";